import { useState, useCallback, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import performance1 from "../assets/images/performance1.jpg";
import "./PerformanceInfo.css";

function Lightbox({ src, onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div
      className="lightbox-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <button
        className="lightbox-close"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
      <img
        src={src}
        alt=""
        className="lightbox-image"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

export default function PerformanceInfo() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const openImage = useCallback(() => setOpen(true), []);
  const closeImage = useCallback(() => setOpen(false), []);

  return (
    <section
      id="performance-info"
      className="performance-info-section"
      aria-label="Performance Information"
    >
      <div className="section-header">
        <h2 className="section-title">{t.performanceInfo.sectionTitle}</h2>
        <div className="section-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
      </div>
      <div className="performance-info-content">
        <button
          type="button"
          className="performance-poster-btn"
          onClick={openImage}
          aria-label={t.performanceInfo.viewPoster}
        >
          <img
            src={performance1}
            alt={t.performanceInfo.posterAlt}
            className="performance-poster"
            loading="lazy"
          />
        </button>
      </div>
      {open && <Lightbox src={performance1} onClose={closeImage} />}
    </section>
  );
}
